import React, { Suspense } from 'react';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

// Lazy load the dashboard component for code splitting
const ClientDashboard = React.lazy(() => import('./components/ClientDashboard'));

// Loading component
const LoadingSpinner = () => (
  <div className="flex items-center justify-center min-h-screen bg-[#1A1D23]">
    <div className="flex flex-col items-center">
      <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-[#FCB634]"></div>
      <p className="mt-4 text-lg text-white font-medium">Loading dashboard...</p>
    </div>
  </div>
);

function App() {
  return (
    <AuthProvider>
      <div className="min-h-screen bg-dark-900 text-gray-100">
        <Suspense fallback={<LoadingSpinner />}>
          <ProtectedRoute>
            <ClientDashboard />
          </ProtectedRoute>
        </Suspense>
      </div>
    </AuthProvider>
  );
}

export default App; 